import { useEffect } from "react";

const useReportDirty = (isDirty: boolean, onDirtyChange?: (dirty: boolean) => void): void => {
	useEffect(() => {
		if (!isDirty) return;
		onDirtyChange?.(true);
		return () => onDirtyChange?.(false);
	}, [isDirty, onDirtyChange]);
};

export default useReportDirty;
